module.exports = __webpack_public_path__ + "img/icon-deposit.e3a4692d.png";